import {
  LOG_TRANSACTION_ALL,
  LOG_TRANSACTION_GET,
  LOG_TRANSACTION_DEL,
  LOG_TRANSACTION_PUT,
  LOG_TRANSACTION_POST,
  LOG_TRANSACTION_LOADING,
  LOG_TRANSACTION_ERROR,
} from '../../actions/types';

const initialState = {
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case LOG_TRANSACTION_LOADING:
      return { isLoading: true, isCompleted: true };
    case LOG_TRANSACTION_ERROR:
      return { isLoading: false, isCompleted: false, ...action.payload };
    case LOG_TRANSACTION_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case LOG_TRANSACTION_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case LOG_TRANSACTION_POST:
      return { isLoading: false, isCompleted: true };
    case LOG_TRANSACTION_PUT:
      return { isLoading: false, isCompleted: true };
    case LOG_TRANSACTION_DEL:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
